interface AssigneeAvatarProps {
  firstName: string;
  lastName: string;
  size?: 'sm' | 'md';
}

/**
 * Circular avatar showing user initials
 * Matches Figma design for assignee display in tables
 */
export const AssigneeAvatar = ({
  firstName,
  lastName,
  size = 'sm',
}: AssigneeAvatarProps) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();

  const sizeClasses = {
    sm: 'h-6 w-6 text-[10px]',
    md: 'h-8 w-8 text-xs',
  };

  return (
    <div
      className={`${sizeClasses[size]} rounded-full bg-[#f5f5f5] dark:bg-zinc-800 text-[#6e6e6e] dark:text-zinc-300 font-semibold inline-flex items-center justify-center uppercase tracking-wider border border-transparent`}
      title={`${firstName} ${lastName}`}
    >
      {initials}
    </div>
  );
};
